/*
 * File: Padding.jsx
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 9, 2022 at 5:45 PM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: July 24, 2024 at 10:53 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Padding.styles';


/**
 * Component
 */

export const Padding = forwardRef(({
	left, right, dynamic, negative, className, children, ...rest
}, ref) => (negative
	? <S.NegativePadding ref={ref} className={className} left={left} right={right} {...rest}>{children}</S.NegativePadding>
	: <S.Padding ref={ref} className={className} left={left} right={right} dynamic={dynamic} {...rest}>{children}</S.Padding>));


/**
 * Configuration
 */

Padding.displayName = 'Padding';
Padding.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	className: PropTypes.string,
	left: PropTypes.bool,
	right: PropTypes.bool,
	dynamic: PropTypes.bool,
	negative: PropTypes.bool
};
Padding.defaultProps = {
	children: null,
	className: null,
	left: false,
	right: false,
	dynamic: false,
	negative: false
};
